import { Flex, IconButton, Text } from "@chakra-ui/react";
import { CloseIcon } from "../../../icons";

const ConfirmPopupTitle = ({
  children,
  color,
  onClose,
}: {
  children: string;
  color: string;
  onClose: () => void;
}) => {
  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      p={"0px 10px 0px 15px"}
      height={10}
      gap={2.5}
      w="100%"
    >
      <Text
        textStyle="body1"
        color={color}
        flexGrow={1}
        textOverflow={"ellipsis"}
        noOfLines={1}
        p={0}
        alignContent={"center"}
        minH={"40px"}
      >
        {children}
      </Text>

      <IconButton
        aria-label="Close popup"
        icon={
          <CloseIcon
            color="--80"
            _hover={{ color: "white" }}
          />
        }
        onClick={onClose}
        w={5}
        h={5}
        minW={5}
        minH={5}
        p={0.5}
        bg="transparent"
        _hover={{ bg: "--w-8_hover" }}
        borderRadius="5px"
        display="flex"
        justifyContent="center"
        alignItems="center"
      />
    </Flex>
  );
};

export default ConfirmPopupTitle;
